module.exports = __webpack_public_path__ + "historical_portfolio.f7b80b7fd30a882944dbe6bf809a5ad4.png";